import { createAction, props } from '@ngrx/store';
import { Parcel } from 'app/core/app.model';
import { Folder, FolderHistory, NotificationDefinition, SavedParcel } from './saved-properties.model';


export const loadFolders = createAction('[Folder] Load folders');

export const createNewFolder = createAction('[Folder] Create New Folder', props<{ parcelsToAdd: Parcel[] }>());

export const submitAddFolder = createAction(
    '[Folder] Confirm Add folder',
    props<{ folderName: string; notificationsEnabled: boolean; parcelsToAdd: Parcel[] }>()
);

export const setFolders = createAction('[Folder] Set folders', props<{ folders: Folder[] }>());

export const requestAddFolder = createAction(
    '[Folder] Request add folder',
    props<{ folderName: string; notificationsEnabled: boolean; parcels: Parcel[] }>()
);

export const addFolder = createAction('[Folder] Add folder', props<{ folder: Folder }>());

export const requestAddParcelsIntoFolder = createAction(
    '[Folder] Request add parcels into folder',
    props<{ id: string; parcels: Parcel[] }>()
);

export const handleRequestAddParcelsIntoFolders = createAction(
    '[Folder] Handle request add parcels into folders',
    props<{ ids: string[]; parcels: Parcel[] }>()
);

export const handleRequestAddParcelsIntoFolder = createAction(
    '[Folder] Handle request add parcels into folder',
    props<{ folder: Folder; parcels: Parcel[] }>()
);

export const addParcelsIntoFolder = createAction(
    '[Folder] Add parcels into folder',
    props<{ folder: Folder; parcels: Parcel[]; updatedAt: string }>()
);

export const openRequestMergeDuplicitiesModal = createAction(
    '[Folder] Open Request merge duplicated properties modal',
    props<{ folder: Folder; parcels: Parcel[]; duplicatedParcels: Parcel[] }>()
);

export const submitRequestMergeDuplicitiesModal = createAction(
    '[Folder] Submit Request merge duplicated properties modal',
    props<{ folder: Folder; parcels: Parcel[]; duplicatedParcels: Parcel[] }>()
);

export const handleOpenNotificationsSettingsModal = createAction(
    '[Folder] Handle open notifications settings modal',
    props<{ folder: Folder }>()
);

export const openNotificationsSettingsModal = createAction(
    '[Folder] Open notifications settings modal',
    props<{ folder: Folder; changeState: boolean; newCollection: boolean }>()
);

export const requestSetNotificationsDefinition = createAction(
    '[Folder] Request set notifications definition',
    props<{ id: string, notificationDefinition: NotificationDefinition }>()
);

export const setNotificationDefinition = createAction(
    '[Folder] Set notifications definition',
    props<{ id: string; notificationDefinition: NotificationDefinition; updatedAt: string; enabled: boolean }>()
);

export const submitAddSelectedParcelsIntoFolder = createAction(
    '[Folder] Submit Add selected parcels into folder',
    props<{ folder: Folder, parcels: Parcel[] }>()
);

export const dismissAddSelectedParcelsIntoFolder = createAction(
    '[Folder] Dismiss Add selected parcels into folder',
    props<{ folder: Folder }>()
);

export const requestSetNotificationStatus = createAction(
    '[Folder] Request set notifications enabled status',
    props<{ id: string, notificationsEnabled: boolean }>()
);

export const setNotificationStatus = createAction(
    '[Folder] Set notifications enabled status',
    props<{ id: string, notificationsEnabled: boolean, updatedAt?: string, expiresAt?: string }>()
);

export const setFolderOpenedState = createAction(
    '[Folder] Set parcel collection opened state',
    props<{ id: string, opened: boolean }>()
);

export const requestRemoveParcelsFromFolder = createAction(
    '[Folder] Request remove parcel from folder',
    props<{ id: string, parcels: SavedParcel[] }>()
);

export const removeParcelsFromFolder = createAction(
    '[Folder] Remove parcel from folder',
    props<{ id: string; upids: string[]; updatedAt: string }>()
);

export const toggleNotifications = createAction('[Folder] Toggle notifications', props<{ id: string, state: boolean }>());

export const requestDeleteFolder = createAction('[Folder] Request delete folder', props<{ id: string }>());

export const deleteFolder = createAction('[Folder] Delete folder', props<{ id: string }>());

type FolderChange = { id: string; updatedAt: string; expiresAt: string };

export const requestRenameFolder = createAction('[Folder] Request rename folder', props<{ id: string; name: string }>());

export const renameFolder = createAction('[Folder] Rename folder', props<FolderChange & { name: string }>());

export const requestRenewFolder = createAction('[Folder] Request nenew folder', props<{ id: string }>());

export const renewFolder = createAction('[Folder] Renew folder', props<FolderChange>());

export const saveParcelsToFolder = createAction('[Folder] Save Parcels to Folder', props<{ parcels: Parcel[] }>());

export const submitAddParcelsIntoFolders = createAction(
    '[Folder] Submit add parcels into folders',
    props<{ ids: string[]; createNewFolder: boolean; parcels: Parcel[] }>()
);

export const dismissAddPropertiesIntoCollections = createAction('[Folder] Dismiss add parcels into folder');

export const loadFolderHistory = createAction('[Folder] Load history', props<{ id: string }>());

export const setFolderHistory = createAction('[Folder] Set history', props<{ id: string; history: FolderHistory }>());

export const openAddParcelsByPidModal = createAction('[Folder] Open add parcels by PID modal', props<{ folder: Folder }>());

export const loadParcels = createAction('[Folder] Load parcels for folder', props<{ id: string }>());

export const setParcels = createAction('[Folder] Set parcels', props<{ id: string, parcels: SavedParcel[] }>());
